var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortugal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M9.217-.003v16.006H0V-.003h9.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M9.218 11a3 3 0 100-6 3 3 0 000 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M7.5 6.5v1.875a1.687 1.687 0 003.375 0V6.5H7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M9.218 8.938a.57.57 0 01-.563-.563v-.75H9.75v.75a.57.57 0 01-.532.563z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugal);
export default __webpack_public_path__ + "static/media/Portugal.81c0e960ea7136af6f381836561d82cc.svg";
export { ForwardRef as ReactComponent };